{
  "NIR_MILLENIAL": {
    "E1": {
      "N": 0.01752091413,
      "P": 0.03002032822
    },
    "E2": {
      "N": 0.01752091413,
      "P": 0.03002032822
    },
    "E3": {
      "N": 0.01752091413,
      "P": 0.03002032822
    },
    "E4": {
      "N": 0.01752091413,
      "P": 0.03002032822
    },
    "E5": {
      "N": 0.01752091413,
      "P": 0.03002032822
    },
    "H1": {
      "N": 0.01515099614,
      "P": 0.02035608368
    },
    "H2": {
      "N": 0.01515099614,
      "P": 0.02035608368
    },
    "H3": {
      "N": 0.01515099614,
      "P": 0.02035608368
    },
    "H4": {
      "N": 0.01515099614,
      "P": 0.02035608368
    },
    "H5": {
      "N": 0.01515099614,
      "P": 0.02035608368
    },
    "S1": {
      "N": 0.03448624704,
      "P": 0.0277466743
    },
    "S2": {
      "N": 0.03448624704,
      "P": 0.0277466743
    },
    "S3": {
      "N": 0.03448624704,
      "P": 0.0277466743
    },
    "S4": {
      "N": 0.03448624704,
      "P": 0.0277466743
    },
    "S5": {
      "N": 0.03448624704,
      "P": 0.0277466743
    },
    "K1": {
      "N": 0.02631578947,
      "P": 0.03296524408
    },
    "K2": {
      "N": 0.03847233891,
      "P": 0.03296524408
    },
    "K3": {
      "N": 0.03847233891,
      "P": 0.03296524408
    },
    "K4": {
      "N": 0.03847233891,
      "P": 0.03296524408
    }
  },
  "NIR_BOOMER": {
    "E1": {
      "N": 0.02724586822,
      "P": 0.02349246341
    },
    "E2": {
      "N": 0.02724586822,
      "P": 0.02349246341
    },
    "E3": {
      "N": 0.02724586822,
      "P": 0.02349246341
    },
    "E4": {
      "N": 0.02724586822,
      "P": 0.02349246341
    },
    "E5": {
      "N": 0.02724586822,
      "P": 0.02349246341
    },
    "H1": {
      "N": 0.0279575225,
      "P": 0.02639450519
    },
    "H2": {
      "N": 0.0279575225,
      "P": 0.02639450519
    },
    "H3": {
      "N": 0.0279575225,
      "P": 0.02639450519
    },
    "H4": {
      "N": 0.0279575225,
      "P": 0.02639450519
    },
    "H5": {
      "N": 0.0279575225,
      "P": 0.02639450519
    },
    "S1": {
      "N": 0.02215140846,
      "P": 0.0241752109
    },
    "S2": {
      "N": 0.02215140846,
      "P": 0.0241752109
    },
    "S3": {
      "N": 0.02215140846,
      "P": 0.0241752109
    },
    "S4": {
      "N": 0.02215140846,
      "P": 0.0241752109
    },
    "S5": {
      "N": 0.02215140846,
      "P": 0.0241752109
    },
    "K1": {
      "N": 0.02631578947,
      "P": 0.03073493543
    },
    "K2": {
      "N": 0.03121985846,
      "P": 0.03073493543
    },
    "K3": {
      "N": 0.03121985846,
      "P": 0.03073493543
    },
    "K4": {
      "N": 0.03121985846,
      "P": 0.03073493543
    }
  },
  "NIR_WORKING": {
    "E1": {
      "N": 0.01828446675,
      "P": 0.02439964401
    },
    "E2": {
      "N": 0.01828446675,
      "P": 0.02439964401
    },
    "E3": {
      "N": 0.01828446675,
      "P": 0.02439964401
    },
    "E4": {
      "N": 0.01828446675,
      "P": 0.02439964401
    },
    "E5": {
      "N": 0.01828446675,
      "P": 0.02439964401
    },
    "H1": {
      "N": 0.02344501839,
      "P": 0.02550733769
    },
    "H2": {
      "N": 0.02344501839,
      "P": 0.02550733769
    },
    "H3": {
      "N": 0.02344501839,
      "P": 0.02550733769
    },
    "H4": {
      "N": 0.02344501839,
      "P": 0.02550733769
    },
    "H5": {
      "N": 0.02344501839,
      "P": 0.02550733769
    },
    "S1": {
      "N": 0.01959043431,
      "P": 0.03164107931
    },
    "S2": {
      "N": 0.01959043431,
      "P": 0.03164107931
    },
    "S3": {
      "N": 0.01959043431,
      "P": 0.03164107931
    },
    "S4": {
      "N": 0.01959043431,
      "P": 0.03164107931
    },
    "S5": {
      "N": 0.01959043431,
      "P": 0.03164107931
    },
    "K1": {
      "N": 0.02631578947,
      "P": 0.04593619114
    },
    "K2": {
      "N": 0.0251998479,
      "P": 0.04593619114
    },
    "K3": {
      "N": 0.0251998479,
      "P": 0.04593619114
    },
    "K4": {
      "N": 0.0251998479,
      "P": 0.04593619114
    }
  },
  "NIR_MOST_WANTED": {
    "E1": {
      "N": 0.02622682893,
      "P": 0.0233193134
    },
    "E2": {
      "N": 0.02622682893,
      "P": 0.0233193134
    },
    "E3": {
      "N": 0.02622682893,
      "P": 0.0233193134
    },
    "E4": {
      "N": 0.02622682893,
      "P": 0.0233193134
    },
    "E5": {
      "N": 0.02622682893,
      "P": 0.0233193134
    },
    "H1": {
      "N": 0.03203766692,
      "P": 0.01939960948
    },
    "H2": {
      "N": 0.03203766692,
      "P": 0.01939960948
    },
    "H3": {
      "N": 0.03203766692,
      "P": 0.01939960948
    },
    "H4": {
      "N": 0.03203766692,
      "P": 0.01939960948
    },
    "H5": {
      "N": 0.03203766692,
      "P": 0.01939960948
    },
    "S1": {
      "N": 0.02867645848,
      "P": 0.02314309
    },
    "S2": {
      "N": 0.02867645848,
      "P": 0.02314309
    },
    "S3": {
      "N": 0.02867645848,
      "P": 0.02314309
    },
    "S4": {
      "N": 0.02867645848,
      "P": 0.02314309
    },
    "S5": {
      "N": 0.02867645848,
      "P": 0.02314309
    },
    "K1": {
      "N": 0.02631578947,
      "P": 0.02901840951
    },
    "K2": {
      "N": 0.03119857881,
      "P": 0.02901840951
    },
    "K3": {
      "N": 0.03119857881,
      "P": 0.02901840951
    },
    "K4": {
      "N": 0.03119857881,
      "P": 0.02901840951
    }
  },
  "NIR_FEMALE": {
    "E1": {
      "N": 0.02748045724,
      "P": 0.02420606549
    },
    "E2": {
      "N": 0.02748045724,
      "P": 0.02420606549
    },
    "E3": {
      "N": 0.02748045724,
      "P": 0.02420606549
    },
    "E4": {
      "N": 0.02748045724,
      "P": 0.02420606549
    },
    "E5": {
      "N": 0.02748045724,
      "P": 0.02420606549
    },
    "H1": {
      "N": 0.0280837727,
      "P": 0.0238304273
    },
    "H2": {
      "N": 0.0280837727,
      "P": 0.0238304273
    },
    "H3": {
      "N": 0.0280837727,
      "P": 0.0238304273
    },
    "H4": {
      "N": 0.0280837727,
      "P": 0.0238304273
    },
    "H5": {
      "N": 0.0280837727,
      "P": 0.0238304273
    },
    "S1": {
      "N": 0.02834034857,
      "P": 0.0257573714
    },
    "S2": {
      "N": 0.02834034857,
      "P": 0.0257573714
    },
    "S3": {
      "N": 0.02834034857,
      "P": 0.0257573714
    },
    "S4": {
      "N": 0.02834034857,
      "P": 0.0257573714
    },
    "S5": {
      "N": 0.02834034857,
      "P": 0.0257573714
    },
    "K1": {
      "N": 0.02631578947,
      "P": 0.02120774691
    },
    "K2": {
      "N": 0.0334536698,
      "P": 0.02120774691
    },
    "K3": {
      "N": 0.0334536698,
      "P": 0.02120774691
    },
    "K4": {
      "N": 0.0334536698,
      "P": 0.02120774691
    }
  },
  "NIR_ASSET_MANAGER": {
    "E1": {
      "N": 0.00613671321,
      "P": 0.01460848775
    },
    "E2": {
      "N": 0.00613671321,
      "P": 0.01460848775
    },
    "E3": {
      "N": 0.00613671321,
      "P": 0.01460848775
    },
    "E4": {
      "N": 0.00613671321,
      "P": 0.01460848775
    },
    "E5": {
      "N": 0.00613671321,
      "P": 0.01460848775
    },
    "H1": {
      "N": 0.01404037103,
      "P": 0.03210999468
    },
    "H2": {
      "N": 0.01404037103,
      "P": 0.03210999468
    },
    "H3": {
      "N": 0.01404037103,
      "P": 0.03210999468
    },
    "H4": {
      "N": 0.01404037103,
      "P": 0.03210999468
    },
    "H5": {
      "N": 0.01404037103,
      "P": 0.03210999468
    },
    "S1": {
      "N": 0.02834763605,
      "P": 0.05474082322
    },
    "S2": {
      "N": 0.02834763605,
      "P": 0.05474082322
    },
    "S3": {
      "N": 0.02834763605,
      "P": 0.05474082322
    },
    "S4": {
      "N": 0.02834763605,
      "P": 0.05474082322
    },
    "S5": {
      "N": 0.02834763605,
      "P": 0.05474082322
    },
    "K1": {
      "N": 0.02631578947,
      "P": 0.05397789039
    },
    "K2": {
      "N": 0.002617506437,
      "P": 0.05397789039
    },
    "K3": {
      "N": 0.002617506437,
      "P": 0.05397789039
    },
    "K4": {
      "N": 0.002617506437,
      "P": 0.05397789039
    }
  },
  "NIR_ASSET_OWNER": {
    "E1": {
      "N": 0.03053891966,
      "P": 0.02805131084
    },
    "E2": {
      "N": 0.03053891966,
      "P": 0.02805131084
    },
    "E3": {
      "N": 0.03053891966,
      "P": 0.02805131084
    },
    "E4": {
      "N": 0.03053891966,
      "P": 0.02805131084
    },
    "E5": {
      "N": 0.03053891966,
      "P": 0.02805131084
    },
    "H1": {
      "N": 0.02821812975,
      "P": 0.0229122573
    },
    "H2": {
      "N": 0.02821812975,
      "P": 0.0229122573
    },
    "H3": {
      "N": 0.02821812975,
      "P": 0.0229122573
    },
    "H4": {
      "N": 0.02821812975,
      "P": 0.0229122573
    },
    "H5": {
      "N": 0.02821812975,
      "P": 0.0229122573
    },
    "S1": {
      "N": 0.02401701716,
      "P": 0.01626705583
    },
    "S2": {
      "N": 0.02401701716,
      "P": 0.01626705583
    },
    "S3": {
      "N": 0.02401701716,
      "P": 0.01626705583
    },
    "S4": {
      "N": 0.02401701716,
      "P": 0.01626705583
    },
    "S5": {
      "N": 0.02401701716,
      "P": 0.01626705583
    },
    "K1": {
      "N": 0.02631578947,
      "P": 0.02457629778
    },
    "K2": {
      "N": 0.0417851889,
      "P": 0.02457629778
    },
    "K3": {
      "N": 0.0417851889,
      "P": 0.02457629778
    },
    "K4": {
      "N": 0.0417851889,
      "P": 0.02457629778
    }
  },
  "NIR_SMALL_AUM": {
    "E1": {
      "N": 0.02911480497,
      "P": 0.00380136917
    },
    "E2": {
      "N": 0.02911480497,
      "P": 0.00380136917
    },
    "E3": {
      "N": 0.02911480497,
      "P": 0.00380136917
    },
    "E4": {
      "N": 0.02911480497,
      "P": 0.00380136917
    },
    "E5": {
      "N": 0.02911480497,
      "P": 0.00380136917
    },
    "H1": {
      "N": 0.02039017817,
      "P": 0.01676811131
    },
    "H2": {
      "N": 0.02039017817,
      "P": 0.01676811131
    },
    "H3": {
      "N": 0.02039017817,
      "P": 0.01676811131
    },
    "H4": {
      "N": 0.02039017817,
      "P": 0.01676811131
    },
    "H5": {
      "N": 0.02039017817,
      "P": 0.01676811131
    },
    "S1": {
      "N": 0.03240548995,
      "P": 0.0283924502
    },
    "S2": {
      "N": 0.03240548995,
      "P": 0.0283924502
    },
    "S3": {
      "N": 0.03240548995,
      "P": 0.0283924502
    },
    "S4": {
      "N": 0.03240548995,
      "P": 0.0283924502
    },
    "S5": {
      "N": 0.03240548995,
      "P": 0.0283924502
    },
    "K1": {
      "N": 0.02631578947,
      "P": 0.03455115367
    },
    "K2": {
      "N": 0.06037252566,
      "P": 0.03455115367
    },
    "K3": {
      "N": 0.06037252566,
      "P": 0.03455115367
    },
    "K4": {
      "N": 0.06037252566,
      "P": 0.03455115367
    }
  },
  "NIR_BIG_AUM": {
    "E1": {
      "N": 0.02240742182,
      "P": 0.03835643079
    },
    "E2": {
      "N": 0.02240742182,
      "P": 0.03835643079
    },
    "E3": {
      "N": 0.02240742182,
      "P": 0.03835643079
    },
    "E4": {
      "N": 0.02240742182,
      "P": 0.03835643079
    },
    "E5": {
      "N": 0.02240742182,
      "P": 0.03835643079
    },
    "H1": {
      "N": 0.02790446901,
      "P": 0.03018659212
    },
    "H2": {
      "N": 0.02790446901,
      "P": 0.03018659212
    },
    "H3": {
      "N": 0.02790446901,
      "P": 0.03018659212
    },
    "H4": {
      "N": 0.02790446901,
      "P": 0.03018659212
    },
    "H5": {
      "N": 0.02790446901,
      "P": 0.03018659212
    },
    "S1": {
      "N": 0.02033408951,
      "P": 0.02286254939
    },
    "S2": {
      "N": 0.02033408951,
      "P": 0.02286254939
    },
    "S3": {
      "N": 0.02033408951,
      "P": 0.02286254939
    },
    "S4": {
      "N": 0.02033408951,
      "P": 0.02286254939
    },
    "S5": {
      "N": 0.02033408951,
      "P": 0.02286254939
    },
    "K1": {
      "N": 0.02631578947,
      "P": 0.02917007178
    },
    "K2": {
      "N": 0.01558205342,
      "P": 0.02917007178
    },
    "K3": {
      "N": 0.01558205342,
      "P": 0.02917007178
    },
    "K4": {
      "N": 0.01558205342,
      "P": 0.02917007178
    }
  },
  "NIR_VC": {
    "E1": {
      "N": 0.02904002342,
      "P": 0.01626150188
    },
    "E2": {
      "N": 0.02904002342,
      "P": 0.01626150188
    },
    "E3": {
      "N": 0.02904002342,
      "P": 0.01626150188
    },
    "E4": {
      "N": 0.02904002342,
      "P": 0.01626150188
    },
    "E5": {
      "N": 0.02904002342,
      "P": 0.01626150188
    },
    "H1": {
      "N": 0.03124360603,
      "P": 0.01994180772
    },
    "H2": {
      "N": 0.03124360603,
      "P": 0.01994180772
    },
    "H3": {
      "N": 0.03124360603,
      "P": 0.01994180772
    },
    "H4": {
      "N": 0.03124360603,
      "P": 0.01994180772
    },
    "H5": {
      "N": 0.03124360603,
      "P": 0.01994180772
    },
    "S1": {
      "N": 0.03048685236,
      "P": 0.01845289395
    },
    "S2": {
      "N": 0.03048685236,
      "P": 0.01845289395
    },
    "S3": {
      "N": 0.03048685236,
      "P": 0.01845289395
    },
    "S4": {
      "N": 0.03048685236,
      "P": 0.01845289395
    },
    "S5": {
      "N": 0.03048685236,
      "P": 0.01845289395
    },
    "K1": {
      "N": 0.02631578947,
      "P": 0.03092307718
    },
    "K2": {
      "N": 0.04095282501,
      "P": 0.03092307718
    },
    "K3": {
      "N": 0.04095282501,
      "P": 0.03092307718
    },
    "K4": {
      "N": 0.04095282501,
      "P": 0.03092307718
    }
  },
  "NIR_PORTFOLIO_MANAGER": {
    "E1": {
      "N": 0.04540026844,
      "P": 0.01244680555
    },
    "E2": {
      "N": 0.04540026844,
      "P": 0.01244680555
    },
    "E3": {
      "N": 0.04540026844,
      "P": 0.01244680555
    },
    "E4": {
      "N": 0.04540026844,
      "P": 0.01244680555
    },
    "E5": {
      "N": 0.04540026844,
      "P": 0.01244680555
    },
    "H1": {
      "N": 0.02958565965,
      "P": 0.01605088418
    },
    "H2": {
      "N": 0.02958565965,
      "P": 0.01605088418
    },
    "H3": {
      "N": 0.02958565965,
      "P": 0.01605088418
    },
    "H4": {
      "N": 0.02958565965,
      "P": 0.01605088418
    },
    "H5": {
      "N": 0.02958565965,
      "P": 0.01605088418
    },
    "S1": {
      "N": 0.03468292233,
      "P": 0.01121273798
    },
    "S2": {
      "N": 0.03468292233,
      "P": 0.01121273798
    },
    "S3": {
      "N": 0.03468292233,
      "P": 0.01121273798
    },
    "S4": {
      "N": 0.03468292233,
      "P": 0.01121273798
    },
    "S5": {
      "N": 0.03468292233,
      "P": 0.01121273798
    },
    "K1": {
      "N": 0.02631578947,
      "P": 0.01011125384
    },
    "K2": {
      "N": 0.06211426817,
      "P": 0.01011125384
    },
    "K3": {
      "N": 0.06211426817,
      "P": 0.01011125384
    },
    "K4": {
      "N": 0.06211426817,
      "P": 0.01011125384
    }
  },
  "NIR_CEO": {
    "E1": {
      "N": 0.02493581494,
      "P": 0.02302983233
    },
    "E2": {
      "N": 0.02493581494,
      "P": 0.02302983233
    },
    "E3": {
      "N": 0.02493581494,
      "P": 0.02302983233
    },
    "E4": {
      "N": 0.02493581494,
      "P": 0.02302983233
    },
    "E5": {
      "N": 0.02493581494,
      "P": 0.02302983233
    },
    "H1": {
      "N": 0.02876899673,
      "P": 0.0171250054
    },
    "H2": {
      "N": 0.02876899673,
      "P": 0.0171250054
    },
    "H3": {
      "N": 0.02876899673,
      "P": 0.0171250054
    },
    "H4": {
      "N": 0.02876899673,
      "P": 0.0171250054
    },
    "H5": {
      "N": 0.02876899673,
      "P": 0.0171250054
    },
    "S1": {
      "N": 0.02228954252,
      "P": 0.02727196721
    },
    "S2": {
      "N": 0.02228954252,
      "P": 0.02727196721
    },
    "S3": {
      "N": 0.02228954252,
      "P": 0.02727196721
    },
    "S4": {
      "N": 0.02228954252,
      "P": 0.02727196721
    },
    "S5": {
      "N": 0.02228954252,
      "P": 0.02727196721
    },
    "K1": {
      "N": 0.02631578947,
      "P": 0.03525592498
    },
    "K2": {
      "N": 0.0385182383,
      "P": 0.03525592498
    },
    "K3": {
      "N": 0.0385182383,
      "P": 0.03525592498
    },
    "K4": {
      "N": 0.0385182383,
      "P": 0.03525592498
    }
  },
  "NIR_HEAD_OF_ESG": {
    "E1": {
      "N": 0.02304287491,
      "P": 0.008299830491
    },
    "E2": {
      "N": 0.02304287491,
      "P": 0.008299830491
    },
    "E3": {
      "N": 0.02304287491,
      "P": 0.008299830491
    },
    "E4": {
      "N": 0.02304287491,
      "P": 0.008299830491
    },
    "E5": {
      "N": 0.02304287491,
      "P": 0.008299830491
    },
    "H1": {
      "N": 0.03590368986,
      "P": 0.02809947066
    },
    "H2": {
      "N": 0.03590368986,
      "P": 0.02809947066
    },
    "H3": {
      "N": 0.03590368986,
      "P": 0.02809947066
    },
    "H4": {
      "N": 0.03590368986,
      "P": 0.02809947066
    },
    "H5": {
      "N": 0.03590368986,
      "P": 0.02809947066
    },
    "S1": {
      "N": 0.0307510364,
      "P": 0.03187663424
    },
    "S2": {
      "N": 0.0307510364,
      "P": 0.03187663424
    },
    "S3": {
      "N": 0.0307510364,
      "P": 0.03187663424
    },
    "S4": {
      "N": 0.0307510364,
      "P": 0.03187663424
    },
    "S5": {
      "N": 0.0307510364,
      "P": 0.03187663424
    },
    "K1": {
      "N": 0.02631578947,
      "P": 0.02915615599
    },
    "K2": {
      "N": 0.02239730125,
      "P": 0.02915615599
    },
    "K3": {
      "N": 0.02239730125,
      "P": 0.02915615599
    },
    "K4": {
      "N": 0.02239730125,
      "P": 0.02915615599
    }
  },
  "NIR_VALUE_FOR_SOCIETY": {
    "E1": {
      "N": 3,
      "P": 3
    },
    "E2": {
      "N": 3,
      "P": 3
    },
    "E3": {
      "N": 3,
      "P": 3
    },
    "E4": {
      "N": 3,
      "P": 3
    },
    "E5": {
      "N": 3,
      "P": 3
    },
    "H1": {
      "N": 3,
      "P": 0
    },
    "H2": {
      "N": 3,
      "P": 0
    },
    "H3": {
      "N": 3,
      "P": 3
    },
    "H4": {
      "N": 3,
      "P": 3
    },
    "H5": {
      "N": 3,
      "P": 3
    },
    "S1": {
      "N": 3,
      "P": 3
    },
    "S2": {
      "N": 3,
      "P": 3
    },
    "S3": {
      "N": 3,
      "P": 5
    },
    "S4": {
      "N": 3,
      "P": 5
    },
    "S5": {
      "N": 3,
      "P": 5
    },
    "K1": {
      "N": 3,
      "P": 2
    },
    "K2": {
      "N": 3,
      "P": 2
    },
    "K3": {
      "N": 3,
      "P": 2
    },
    "K4": {
      "N": 3,
      "P": 2
    }
  }
}